import { cn } from '../cn';

export interface LogoProps {
  /** Micro line under the name ("FDGTV · Cloud", "Local · hotspot"). */
  sub?: string;
  className?: string;
  markOnly?: boolean;
}

/** Lockup: 26 px radius-7 mark in fg with mono 600 11px "G1" (the model badge), "Glyph" 500 13px, optional micro sub.
 *  The product is Glyph Control; the model name lives on the mark only. */
export function Logo({ sub, className, markOnly }: LogoProps) {
  return (
    <div className={cn('flex items-center gap-2.5', className)}>
      <div aria-hidden className="grid h-[26px] w-[26px] flex-none place-items-center rounded-md bg-fg font-mono text-sm font-semibold text-bg">
        G1
      </div>
      {!markOnly && (
        <div className="flex min-w-0 flex-col gap-1">
          <span className="text-md font-medium leading-none">Glyph</span>
          {sub && <span className="micro text-fg4">{sub}</span>}
        </div>
      )}
    </div>
  );
}
